import { EnumLanguage } from '../enums/language.enum';
import { BrowserStorage } from './browserStorage';

export const LANGUAGE_STORAGE_KEY = 'appLanguage';

const SUPPORTED_LANGUAGES = Object.values(EnumLanguage);

export function getCurrentLanguage(): EnumLanguage {
  const storedLanguage = BrowserStorage.get(LANGUAGE_STORAGE_KEY);
  const supportedStoredLanguage = SUPPORTED_LANGUAGES.find((language) => language === storedLanguage);
  if (supportedStoredLanguage) {
    return supportedStoredLanguage;
  }
  return getBrowserLanguage();
}

function getBrowserLanguage(): EnumLanguage {
  const preferredLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const preferredLanguage of preferredLanguages) {
    const normalizedLanguage = preferredLanguage?.toLowerCase() ?? '';
    const matchedLanguage = SUPPORTED_LANGUAGES.find((language) => normalizedLanguage.startsWith(language));
    if (matchedLanguage) {
      return matchedLanguage;
    }
  }
  return EnumLanguage.SPANISH;
}
